import { useEffect, useState, createContext } from "react";

export const ColorModeContext = createContext();

export const ColorModeProvider = ({ children }) => {
	const [colorMode, setColorMode] = useState(localStorage.getItem("colorTheme") === "1" ? "dark" : "light");

	useEffect(() => {
		$(document).on("ColorThemeModified", () => {
			let colorSetting = localStorage.getItem("colorTheme");
			setColorMode(colorSetting === "0" ? "light" : "dark");
		});
	}, []);

	return <ColorModeContext.Provider value={{ colorMode, setColorMode }}>{children}</ColorModeContext.Provider>;
};
